import { removeAxiosAuth, setAxiosAuth } from "./axios.js";

export function jwtDecode(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join('')
    );

    return JSON.parse(jsonPayload);
}

export const tokenExpired = (exp) => {
    console.log(exp);
    // eslint-disable-next-line prefer-const
    let expiredTimer;

    const currentTime = Date.now();

    // Test token expires after 10s
    // const timeLeft = currentTime + 10000 - currentTime; // ~10s
    const timeLeft = exp * 1000 - currentTime;
    console.log(timeLeft);

    clearTimeout(expiredTimer);

    expiredTimer = setTimeout(() => {
        alert('Token expired');

        localStorage.removeItem('accessToken');

        window.location.href = window.location.host;
    }, timeLeft);
};

export const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false;
    }

    const decoded = jwtDecode(accessToken);

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
};


export const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('jwt', accessToken);
        setAxiosAuth(accessToken)

        // This function below will handle when token is expired
        // const { exp } = jwtDecode(accessToken);
        // tokenExpired(exp);
    } else {
        localStorage.removeItem('jwt');
        removeAxiosAuth()
    }
};
